import { Input } from 'antd';
import { Dispatch, FC, SetStateAction, useRef } from 'react';
import { FieldData } from 'models';

import { FormItem } from 'componets/form';

import Utils from 'utils/utils';
import { Rules } from 'utils/constants';

import styles from './index.module.scss';

interface SaleProjectInputProps {
	maxPrice: number;
	minPrice: number;
	setFields: Dispatch<SetStateAction<FieldData[]>>;
}
export const RangeSliderInput: FC<SaleProjectInputProps> = ({ maxPrice, minPrice, setFields }) => {
	const inputRef = useRef<any>(null);

	const onFocus = () => {
		if (inputRef.current) {
			inputRef.current.select();
		}
	};

	return (
		<div className={styles.root}>
			<span>€</span>&nbsp;
			<FormItem
				className={styles.inputWrapper}
				name="amount"
				rules={[Rules.REQUIRED_SELECT]}
				normalize={Utils.transformToFixedNumber}
			>
				<Input
					onFocus={onFocus}
					ref={inputRef}
					className={styles.input}
					onBlur={(e) => {
						setFields([
							{
								name: ['amount'],
								value: Utils.transformToRangeNumber(+e.target.value, minPrice, maxPrice).toFixed(2),
							},
						]);
					}}
				/>
			</FormItem>
		</div>
	);
};
